import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useDispatch } from "react-redux";

import { enableModal } from "../../store/mainReducer";
import { MainButton } from "../../components/MainButton";
import { COLORS } from "../../utils/colors";

export const SuccessMessage = () => {
  const dispatch = useDispatch();

  function handleClick() {
    dispatch(enableModal(false));
  }

  return (
    <div>
      <CheckCircleIcon sx={{ color: COLORS.mainAccent, fontSize: 60 }} />
      <h2>Success!</h2>
      <MainButton
        text="Continue"
        onClickAction={handleClick}
        color={COLORS.black}
        textColor={COLORS.white}
        textHoverColor={COLORS.white}
        hoverColor={COLORS.mainAccent}
        shadowColor={"transparent"}
      />
    </div>
  );
};
